import {createSlice, PayloadAction} from "@reduxjs/toolkit";

export interface WatchlistItem {
  id: number;
  title?: string;
  name?: string;
  poster_path?: string;
  vote_average?: number;
  type: "movie" | "tv";
}

interface WatchlistState {
  items: WatchlistItem[];
}

const initialState: WatchlistState = {items: []};

const watchlistSlice = createSlice({
  name: "watchlist",
  initialState,
  reducers: {
    addToWatchlist(state, action: PayloadAction<WatchlistItem>) {
      if (!state.items.find((i) => i.id === action.payload.id)) {
        state.items.unshift(action.payload);
      }
    },
    removeFromWatchlist(state, action: PayloadAction<number>) {
      state.items = state.items.filter((i) => i.id !== action.payload);
    },
    clearWatchlist(state) {
      state.items = [];
    },
  },
});

export const {addToWatchlist, removeFromWatchlist, clearWatchlist} = watchlistSlice.actions;
export default watchlistSlice.reducer;
